<template>
  <v-container fluid>
    <v-card class="pa-4 pt-3">
      <v-row>
        <v-col>
          <h4 class="mb-2">{{ formattedDate }}</h4>
          <v-timeline dense>
            <v-timeline-item
              v-for="event in sortedEvents"
              :key="event.id"
              :color="event.color || 'primary'"
              small
            >
              <template #opposite>
                {{ formatTime(event.date) }}
              </template>
              <v-card>
                <v-card-text>{{ event.name }}</v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue';
import { format, parseISO } from 'date-fns';

type CalEvent = {
  id: number;
  date: string;        // ISO
  name: string;
  color?: string;
  original?: any;
};

type CalendarConfig = {
  dateField: string;   // path en original
  labelField: string;
  colorField?: string;
};

export default defineComponent({
  name: 'CalendarDay',
  props: {
    baseDate: { type: Date, required: true },
    events: { type: Array as PropType<CalEvent[]>, required: true },
    title: { type: Object as PropType<{ singular: string }>, required: true },
    moduleName: { type: String, required: true },
    onCreate: { type: Function as PropType<(data: { date: string }) => void>, required: false },
    calendarConfig: { type: Object as PropType<CalendarConfig>, required: true },
  },
  setup(props) {
    const formattedDate = computed(() => format(props.baseDate, 'eeee dd MMMM yyyy'));
    const formatTime = (datetime: string) => format(new Date(datetime), 'HH:mm');

    function normalizeDate(input: string): string {
      const date = parseISO(input);
      return format(date, 'yyyy-MM-dd');
    }

    const sortedEvents = computed(() => {
      const dateStr = format(props.baseDate, 'yyyy-MM-dd');
      return props.events
        .filter(e => normalizeDate(e.original?.[props.calendarConfig.dateField]) === dateStr)
        .sort(
          (a, b) =>
            new Date(a.original?.[props.calendarConfig.dateField]).getTime() -
            new Date(b.original?.[props.calendarConfig.dateField]).getTime()
        );
    });

    return {
      formattedDate,
      formatTime,
      sortedEvents,
    };
  },
});
</script>

<style scoped>
</style>
